export default __webpack_public_path__ + "static/media/6.3cb997d8.mp4";